var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNssLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 550",
    style: {
      enableBackground: "new 0 0 1500 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0C4A29;}\r\n\t.st1{fill:#0E6A36;}\r\n\t.st2{fill:#59A946;}\r\n\t.st3{fill:#95C93F;}\r\n\t.st4{fill:#009445;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.2,469.5c0,0-1.8-306.4,16.5-392.5c0,0,1.8,133.6,3.8,172.2c2.7,50.8,14.6,119.4,16.6,136.9 c2.6,22.2,12.1,76-5.8,83.7C222.3,472.1,196.2,469.5,196.2,469.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145,469.8c0,0-1.4-237.4,12.8-304.2c0,0,1.4,103.5,2.9,133.5c2.1,39.4,11.3,92.5,12.9,106.1 c2,17.2,9.4,58.9-4.5,64.9C165.2,471.8,145,469.8,145,469.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.3,470c0,0-1-170.7,9.2-218.7c0,0,1,74.5,2.1,96c1.5,28.3,8.1,66.5,9.3,76.3c1.4,12.4,6.7,42.3-3.3,46.7 C113.8,471.5,99.3,470,99.3,470z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.9,470.3c0,0-0.7-114.6,6.2-146.9c0,0,0.7,50,1.4,64.5c1,19,5.5,44.7,6.2,51.2c1,8.3,4.5,28.4-2.2,31.3 C62.6,471.3,52.9,470.3,52.9,470.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "262.9,344.1 290,344.1 290,261.8 341.7,344.1 370.8,344.1 370.8,209.6 340.7,209.6 341.3,293.6  289.6,209.6 262.9,209.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "706,233.1 706,344.1 732.9,344.1 732.9,233.1 772.1,233.1 772.1,209.6 667.3,209.6 667.3,233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1125.4,233.1 1125.4,344.1 1152.4,344.1 1152.4,233.1 1191.5,233.1 1191.5,209.6 1086.7,209.6  1086.7,233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "789.8,209.6 789.8,344.1 814.1,344.1 814.1,284.4 867.4,284.4 867.4,344.1 894.8,344.1 894.8,209.6  867.8,209.6 867.8,263.4 813.6,263.4 813.6,209.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1125.1,
    y: 383.3,
    className: "st4",
    width: 23.8,
    height: 86.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1202.8,383.3 1202.8,469.7 1224.2,469.7 1224.2,414.5 1267.3,469.8 1286.8,469.8 1286.8,383.3  1265.9,383.3 1265.9,441.6 1223,383.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1258.5,209.6h-24.1L1180,344.1h28.5l11.9-30h52.6l12.2,30h28.5L1258.5,209.6z M1226.7,293l19.9-50.1 l19.9,50.1H1226.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "697,383.3 697,469.8 751,469.8 751,452 717.9,452 717.9,437 747.9,437 747.9,419 717.9,419  717.9,401.2 751,401.2 751,383.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "586.4,383.3 586.4,403.9 607.2,403.9 607.2,469.8 631.1,469.8 631.1,404 652.3,404 652.3,383.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1429.5,
    cy: 460.2,
    r: 12.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "793.1,469.8 808.1,383.3 831.4,383.3 846.3,437.2 862.8,383.3 885.5,383.3 899.9,469.8 876.9,469.8  869.6,419.1 854.4,469.8 839.3,469.8 824.4,418.9 816.5,469.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "367.1,383.3 397.8,428.7 397.8,469.9 421.7,469.9 421.7,428.7 451.9,383.3 426,383.3 411.2,412.7  394,383.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1402.1,284c0,0,36.4-0.6,34.6-37.1c-1.7-35.9-40.5-37.3-40.5-37.3h-68.4v134.5h24.7v-56.7l18.4,0.3 c20,13.2,42.2,56.4,42.2,56.4h34.1C1426.3,303.7,1402.1,284,1402.1,284z M1352.8,268.6v-35.5c18.6-0.1,56.7-2.4,56.7,16.9 C1409.5,272.6,1352.8,268.6,1352.8,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M616.6,284c0,0,36.4-0.6,34.6-37.1c-1.7-35.9-40.5-37.3-40.5-37.3h-68.4v134.5H567v-56.7l18.4,0.3 c20,13.2,42.2,56.4,42.2,56.4h34.1C640.8,303.7,616.6,284,616.6,284z M567.3,268.6v-35.5c18.6-0.1,56.7-2.4,56.7,16.9 C624,272.6,567.3,268.6,567.3,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M966.4,299.1h27.3c0,0-0.5,23.9,26.3,23.9c26.7,0,25.7-16.3,25.7-16.3s4.8-14.6-34.7-20.9 c-39.5-6.3-41.1-30.9-41.3-37.5c-0.2-5.4,1.8-39.5,47.5-39.5c45.6,0,52.5,30.1,55,42.4h-28.7c0,0-1.8-20.8-24.9-20.9 c-15.3-0.1-22.1,6.6-22.1,13.7c0,8,3.2,10.6,30,16.1c27.3,5.6,43,22,45.8,29.3c3.7,9.6,5.4,32.1-10.6,44.4 c-15.1,11.6-30,12.8-40.7,12.8S968.3,346.9,966.4,299.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1382.8,451.3c-13.4,0-24.3-10.9-24.3-24.3c0-13.4,10.9-24.3,24.3-24.3c8.4,0,15.9,4.3,20.2,10.8v-26.2 c-6.5-3.6-13.9-5.7-21.9-5.7c-24.8,0-45,20.1-45,45s20.1,45,45,45c8,0,15.4-2.1,21.9-5.7v-25.3 C1398.7,447,1391.3,451.3,1382.8,451.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M457.3,207.8c-35.8,0-64.7,31.3-64.7,69.9s29,69.9,64.7,69.9c35.8,0,64.7-31.3,64.7-69.9 S493,207.8,457.3,207.8z M458.7,322.5c-23.4,0-42.3-20.4-42.3-45.7s18.9-45.7,42.3-45.7c23.4,0,42.3,20.4,42.3,45.7 C501.1,302.1,482.1,322.5,458.7,322.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M323.2,406.3l8.6-15.8c0,0-10.2-8.1-26.5-8c-16.3,0.2-29.3,7.1-30.4,28.7c-1.1,22.7,38.6,21.5,38.8,34.2 c0.1,6.7-5.3,9-12.1,8.9c-6.9-0.2-18.6-12.2-18.6-12.2l-11.6,17.5c0,0,12,13.3,31,13.1c18.9-0.1,33.2-12.4,33.2-30.5 c0-10.5-0.9-20.6-28.6-28.5c-2.5-0.7-9.7-1.4-9.6-7.4c0.1-6,8.3-7.1,12-6.3C313,400.8,321.8,403.7,323.2,406.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M535.5,406.3l8.6-15.8c0,0-10.2-8.1-26.5-8c-16.3,0.2-29.3,7.1-30.4,28.7c-1.1,22.7,38.6,21.5,38.8,34.2 c0.1,6.7-5.3,9-12.1,8.9c-6.9-0.2-18.6-12.2-18.6-12.2l-11.6,17.5c0,0,12,13.3,31,13.1c18.9-0.2,33.2-12.4,33.2-30.5 c0-10.5-0.9-20.6-28.6-28.5c-2.5-0.7-9.7-1.4-9.6-7.4c0.1-6,8.3-7.1,12-6.3C525.3,400.8,534.1,403.7,535.5,406.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M991.8,406.3l8.6-15.8c0,0-10.2-8.1-26.5-8c-16.3,0.2-29.3,7.1-30.4,28.7c-1.1,22.7,38.6,21.5,38.8,34.2 c0.1,6.7-5.3,9-12.1,8.9c-6.9-0.2-18.6-12.2-18.6-12.2L940,459.6c0,0,12,13.3,31,13.1c18.9-0.1,33.2-12.4,33.2-30.5 c0-10.5-0.9-20.6-28.6-28.5c-2.5-0.7-9.7-1.4-9.6-7.4c0.1-6,8.3-7.1,12-6.3C981.7,400.8,990.4,403.7,991.8,406.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNssLogo);
export default __webpack_public_path__ + "static/media/nss-logo.6fd2b284cbd2a4e79c2b7afcbe244c75.svg";
export { ForwardRef as ReactComponent };